import { render, staticRenderFns } from "./ApprovedByColumn.vue?vue&type=template&id=00dc2863&scoped=true"
import script from "./ApprovedByColumn.vue?vue&type=script&lang=ts"
export * from "./ApprovedByColumn.vue?vue&type=script&lang=ts"
import style0 from "./ApprovedByColumn.vue?vue&type=style&index=0&id=00dc2863&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc2863",
  null
  
)

export default component.exports